<script>
import TableList from '@/components/TableList.vue'
import * as components from './TableList/'
export default {
  extends: TableList,
  components
}
</script>
<style lang="scss">
.table-list.manufacture {
  .column-manufacture {
    position: relative;
    .column-manufacture-inner {
      padding: 15px;
      display: flex;
      flex-wrap: wrap;
      .manufacture-title {
        font-weight: bold;
        margin-bottom: 10px;
        width: 100%;
      }
      .manufacture-thumbnail {
        width: 200px;
        height: 200px;
        float: left;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .manufacture-main {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        label {
          margin-right: 5px;
        }
      }
      .manufacture-summary {
        width: 250px;
        margin-right: 20px;
      }

      .manufacture-meta {
        min-width: 250px;
        p {
          margin-bottom: 0;
        }
        ul li {
          white-space: pre-line;
        }
      }
    }
  }
}
</style>
